$(() => {

    setupContestDetail();

});

let setupContestDetail = () => {

    let setupDivisionListInvitation = () => 
    {

        $('.division-list-td').on('click', (event) => 
        {    
            let playerId = $(event.target).attr('data-playerId');
            let playerCheckbox = $('#selectedPlayer-checkbox-' + playerId);

            if(playerCheckbox.prop('checked') == true) 
            {
                playerCheckbox.prop('checked', false);
            }
            else 
            {
                playerCheckbox.prop('checked', true);
            }
        });


    }



    setupDivisionListInvitation();

}